<div class="max-w-4xl mx-auto mb-2 mt-6">

    <div class="flex gap-3">

        <!-- Partner Developer Keys -->
        <button (click)="activeTab='keys'" [ngClass]="activeTab === 'keys'
                ? 'bg-blue-700 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'" class="px-5 py-2 rounded-md font-medium transition">

            Partner Developer Keys

        </button>

        <!-- Credential Instructions -->
        <button (click)="activeTab='instructions'" [ngClass]="activeTab === 'instructions'
                ? 'bg-blue-700 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'" class="px-5 py-2 rounded-md font-medium transition">

            Credential and Authorization Instructions

        </button>

    </div>

</div>

<div *ngIf="activeTab === 'keys'">
    <div class="bg-white rounded-lg shadow-md p-6 max-w-4xl mx-auto">
        <h1 class="text-xl font-semibold text-blue-700 mb-6">{{ 'PROFILE.TITLE' | translate }}</h1>

        <div class="bg-gray-50 rounded-lg p-6 mb-6">
            <h2 class="text-lg font-medium mb-4">{{ 'PROFILE.API_KEYS' | translate }}</h2>

            <div class="border-t border-gray-200">
                <div class="grid grid-cols-3 py-3 text-sm text-gray-500 font-medium">
                    <div>{{ 'PROFILE.DESC' | translate }}</div>
                    <div>{{ 'PROFILE.DATE' | translate }}</div>
                    <div>{{ 'PROFILE.STATUS' | translate }}</div>
                </div>

                <div class="border-t border-gray-200 grid grid-cols-3 py-3">
                    <div class="font-medium">{{ 'PROFILE.DEFAULT' | translate }}</div>
                    <!-- <div>
                    Key:
                    <button class="text-blue-600 font-medium inline-flex items-center" (click)="toggleKeyVisibility(1)">
                        Show API Key
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                        </svg>
                    </button>
                </div> -->

                    <!-- <div>
                    Key:
                    <button class="text-blue-600 font-medium inline-flex items-center"
                        (click)="toggleDefaultKeyVisibility()">
                        {{ showKey ? 'Hide API Key' : 'Show API Key' }}
                    </button>
                    <button class="text-blue-400 mr-2" (click)="copyDefaultKey(data.defaultKey)">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                        </svg>
                    </button>

                    <span *ngIf="copiedDefault" class="text-green-600 text-xs ml-2">{{ 'PROFILE.COPIED' | translate
                        }}!</span>

                    <div *ngIf="showKey && apiKey" class="mt-2 font-mono text-sm bg-gray-100 p-2 rounded">
                        {{ apiKey }}
                    </div>
                </div> -->

                    <div class="text-green-500 font-medium">Active</div>
                </div>
            </div>

            <div class="flex justify-between items-start mt-4">

                <!-- Left Side (User Info) -->
                <div class="space-y-2">

                    <div class="flex">
                        <div class="text-gray-500 mr-1">{{ 'PROFILE.ASSOCIATED_USER' | translate }}:</div>
                        <div>{{ data.userName }}</div>
                    </div>

                    <div class="flex">
                        <div class="text-gray-500 mr-1">{{ 'PROFILE.USER_ROLES' | translate }}:</div>
                        <div>{{ data.roles.join(', ') }}</div>
                    </div>

                    <div class="flex">
                        <div class="text-gray-500 mr-1">{{ 'PROFILE.EXPIRATION' | translate }}:</div>
                        <div>{{ data.expiration }}</div>
                    </div>

                </div>

                <!-- Right Side (Encryption Function) -->
                <div class="border rounded-lg p-4 bg-white shadow-sm min-w-[220px]">

                    <div class="text-center font-semibold mb-3 text-[#800000]">
                        Encryption Function
                    </div>

                    <div class="flex justify-center space-x-6">

                        <label class="flex items-center cursor-pointer">
                            <input type="radio" name="encryptionType" [checked]="partnerSymetricAlg" disabled
                                class="mr-1" />
                            <span>Symmetric</span>
                        </label>

                        <label class="flex items-center cursor-pointer">
                            <input type="radio" name="encryptionType" [checked]="!partnerSymetricAlg" disabled
                                class="mr-1" />
                            <span>Asymmetric</span>
                        </label>

                    </div>

                </div>

            </div>

            <h2 class="text-lg font-medium mt-8 mb-4">{{ 'PROFILE.API_KEYS' | translate }}</h2>

            <div class="border-t border-gray-200">
                <div class="grid grid-cols-3 py-3 text-sm text-gray-500 font-medium">
                    <div>{{ 'PROFILE.NAME' | translate }}</div>
                    <div>{{ 'PROFILE.TYPE' | translate }}</div>
                    <div>{{ 'PROFILE.KEY' | translate }}</div>
                </div>
                <ng-container *ngFor="let key of data.apiKeys; let i = index">
                    <div class="border-t border-gray-200 grid grid-cols-3 py-3">
                        <div>
                            <a class="text-blue-600" href="javascript:void(0)">{{ key.name }}</a>
                        </div>
                        <div>{{ key.type }}</div>
                        <div class="flex items-center justify-between">
                            <div class="flex items-center">
                                <!-- Copy Button -->
                                <button class="text-blue-400 mr-2" (click)="copyKey(key.value, i)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                    </svg>
                                </button>
                                <span *ngIf="copiedIndex === i" class="text-green-600 text-xs">Copied!</span>
                                <!-- Eye Button -->
                                <button class="text-blue-400 mr-2" (click)="toggleKeyVisibility(i)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                    </svg>
                                </button>

                                <!-- Show/hide actual value -->
                                <span class="text-gray-800">{{ showKeys[i] ? key.value : '••••••••••••••••••••••'
                                    }}</span>
                            </div>

                            <div *ngIf="key.allowReset">
                                <button class="ml-4 bg-blue-700 hover:bg-blue-800 text-white px-3 py-1 rounded text-sm"
                                    (click)="resetApiKey()">
                                    {{ 'PROFILE.RESET' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>


            </div>
            <div class="mt-10 flex justify-between items-start">
                <div class="flex flex-col items-center space-y-3">
                    <button class="bg-blue-700 hover:bg-blue-800 text-white px-6 py-2 rounded"
                        (click)="generateNewKey()">
                        Generate Public and Private Key
                    </button>
                    <span class="font-bold text-gray-700">OR</span>
                    <button class="px-6 py-2 rounded font-semibold" style="background-color: #FFC90E; color: black;" (click)="openPublicKeyModal()">
                        Enter a Public Key
                    </button>

                </div>

                <p class="text-sm text-gray-600 ml-4 max-w-md">
                    Asymmetric Functions requires you use JWTs for Authentication.
                    The JWTs must be signed with your private key.
                    Provide your own keys, or we can generate them for you.
                </p>
            </div>
        </div>

        <div class="flex justify-end">
            <button class="bg-red-600 hover:bg-red-700 text-white px-8 py-2 rounded" (click)="close()">
                {{ 'COMMON.CLOSE' | translate }}
            </button>
        </div>
        <app-generate-key-result *ngIf="showKeyModal" [fileBlob]="keyFile" (close)="showKeyModal=false">
        </app-generate-key-result>
    </div>
</div>




<div *ngIf="activeTab === 'instructions'" class="bg-white rounded-lg shadow-md p-6 max-w-4xl mx-auto">
    <h1 class="text-2xl font-semibold text-blue-700 mb-6">
        Credential and Authorization Instructions
    </h1>

    <div class="space-y-8 text-sm text-gray-700 leading-7">

        <div>
            <h2 class="text-xl font-semibold text-gray-800 mb-3">Credentials, and Authorization</h2>
            <p>
                On this page, you'll find information about credentials, certificates and authorization
                for the <span class="font-semibold">{{user.ownerName}} API</span>.
            </p>
        </div>

        <div>
            <h2 class="text-xl font-semibold text-gray-800 mb-3">Authorization with OAuth2</h2>
            <p>
                The permission mechanism for requests made to the <span class="font-semibold">{{user.ownerName}}
                    API</span>
                is compatible with the OAuth2 protocol. This means that it follows a set of rules and standards
                to authorize requests made to the API.
            </p>
        </div>

        <div>
            <h2 class="text-xl font-semibold text-gray-800 mb-3">The Purpose of OAuth2</h2>
            <p>
                To authorize all calls made to the API, it is necessary to obtain an access token.
                This token is used to verify if a particular application has permission to use the
                requested endpoint in the API.
            </p>
        </div>

        <div>
            <h2 class="text-xl font-semibold text-gray-800 mb-3">How Request Authentication Is Done</h2>
            <p class="mb-4">
                Authentication can be performed with two different methods, depending of settings set on your
                Partner Account.
            </p>

            <div class="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4">
                <h3 class="text-lg font-semibold text-blue-700 mb-2">1st Method</h3>
                <p>
                    Authentication is performed using <span class="font-semibold">HTTP Basic Auth</span>,
                    which requires the Username and Password of the application you have in your
                    <span class="font-semibold">{{user.ownerName}} account</span>. With this authentication,
                    OAuth can provide information about the permissions granted to the application,
                    allowing authorization or denial of requests based on this information.
                </p>
            </div>

            <div class="bg-gray-50 border border-gray-200 rounded-lg p-4">
                <h3 class="text-lg font-semibold text-blue-700 mb-2">2nd Method</h3>
                <p>
                    Authentication is performed using <span class="font-semibold">Private JWT Private Key JWT</span>,
                    which requires a JWT signed by the Partner's private key created or generated in the
                    developer Portal page, along your <span class="font-semibold">{{user.ownerName}} account</span>.
                    With this authentication, OAuth can provide information about the permissions granted to the
                    application, allowing authorization or denial of requests based on this information.
                </p>
            </div>
        </div>

        <div class="bg-shape-color p-4 rounded-lg">
            <h2 class="text-2xl font-semibold">Obtaining Token Authorization</h2>
        </div>

        <div class="border rounded-lg p-5 bg-white shadow-sm">
            <h3 class="text-xl font-semibold text-gray-800 mb-3">1st Method</h3>
            <div class="mb-4">
                <div class="font-medium text-gray-900">POST /api/partners/manager/v1/oauth2/authorize</div>
            </div>

            <h4 class="text-lg font-semibold text-blue-700 mb-3">
                Examples of Authorization using the Credentials Method
            </h4>

            <p class="mb-4">
                The endpoint <span class="font-semibold">POST /oauth2/authorize</span> is used to authorize
                the credentials of an application and obtain the necessary accesses to use other resources of the API.
            </p>

            <div class="bg-black text-white rounded-lg p-4 overflow-x-auto text-sm mb-6">
                <pre class="bg-black whitespace-pre-wrap" ngNonBindable>curl --location '<span class="text-[#e6db74]">BASE_URL/neobank/api/partners/manager/v1/oauth2/authorize</span>' \
--header 'grantType: client_credential' \
--header 'Content-Type: application/json' \
--header 'Authorization: ••••••' \
--data '&#123;
    "apiUser": "INSERT_YOUR_PARTNER_API_USER",
    "apiKey": "INSERT_YOUR_PARTNER_API_KEY"
&#125;'</pre>
            </div>

            <div class="overflow-x-auto mb-6">
                <table class="min-w-full border border-gray-200 text-sm">
                    <thead class="bg-gray-100">
                        <tr>
                            <th class="px-4 py-3 text-left border-b">Attribute</th>
                            <th class="px-4 py-3 text-left border-b">Description</th>
                            <th class="px-4 py-3 text-left border-b">Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="border-b">
                            <td class="px-4 py-3 font-medium">Authorization</td>
                            <td class="px-4 py-3">Basic auth of your Username and Password</td>
                            <td class="px-4 py-3">string</td>
                        </tr>
                        <tr class="border-b">
                            <td class="px-4 py-3 font-medium">apiUser</td>
                            <td class="px-4 py-3">This is retrieved in your Developer Portal</td>
                            <td class="px-4 py-3">string</td>
                        </tr>
                        <tr>
                            <td class="px-4 py-3 font-medium">apiKey</td>
                            <td class="px-4 py-3">This is retrieved in your Developer Portal</td>
                            <td class="px-4 py-3">UUID</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <h4 class="text-lg font-semibold text-blue-700 mb-3">Example of authorization response</h4>
            <p class="mb-4">
                Below is a code snippet representing an example of the OAuth response to your authorization request:
            </p>

            <div class="bg-black text-white rounded-lg p-4 overflow-x-auto text-sm mb-6">
                <pre class="bg-black whitespace-pre-wrap" ngNonBindable>&#123;
    "success": true,
    "message": "Login Successfully",
    "userDTO": &#123;
        "senderId": 23508,
        "tokenResponseDTO": &#123;
            "success": true,
            "message": "User Token Processed successfully",
            "tokenType": "Bearer",
            "accessToken": "eyJjdHkiOiJKV1QiLCJlbmMiOiJBMjU2R0NNIiwiYWxnIjoiZGlyIn0..cz9qafT08PZFsNLK.R_UOeMtDaG3IhtoQs6TOdLfDiSpYfAv4UfgDbs1SoI5HExtwpeNpFmZ79ZEblWFKTYP675uzTM_kaqnR7ZNhN2zG00sOJ0eQPLnG1QsCL50gqqKSXHp8aCzF6Crn2_MDQi5ly_D871Fb2fcvzgpNqGb_Zdv1o8YkpKS4wI52m5dcr1SLf6EOTu5g4te12Gv0NPFu7GD1UDHOhd1YqbnuwljOWrxRRnQ_2et1rTM1xGc.M9m3btLWyMzmV6Lna0M8Pw",
            "expiresIn": 1800,
            "scope": "MANAGER",
            "refreshToken": "2m8xhfIb0-_Szo-K5sULNq3_eQxUua20jmNkNFvDkG4="
        &#125;,
        "commissionSenderIds": [
            13
        ],
        "grantType": "client_credential"
    &#125;,
    "encryptedTellerKey": "3jJ2lOhzxxaNQMbKNeo8HxrztP9jglYvEELAiNRlS3c=",
    "dynamicSalt": "ey35Irt4TLsD1lun",
    "tellerSecretKey": "1fd029"
&#125;</pre>
            </div>

            <p class="mb-4">
                The table below describes the attributes present in the returned JSON.
            </p>

            <div class="overflow-x-auto">
                <table class="min-w-full border border-gray-200 text-sm">
                    <thead class="bg-gray-100">
                        <tr>
                            <th class="px-4 py-3 text-left border-b">Attribute</th>
                            <th class="px-4 py-3 text-left border-b">Description</th>
                            <th class="px-4 py-3 text-left border-b">Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="border-b">
                            <td class="px-4 py-3 font-medium">access_token</td>
                            <td class="px-4 py-3">Authorization token to be used in other requests made to the API.</td>
                            <td class="px-4 py-3">string</td>
                        </tr>
                        <tr class="border-b">
                            <td class="px-4 py-3 font-medium">token_type</td>
                            <td class="px-4 py-3">Type of authorization the access_token should be used with. Default:
                                "Bearer"</td>
                            <td class="px-4 py-3">string</td>
                        </tr>
                        <tr class="border-b">
                            <td class="px-4 py-3 font-medium">expires_in</td>
                            <td class="px-4 py-3">Expiration time of the access_token in seconds. Default: 3600</td>
                            <td class="px-4 py-3">Integer (int32)</td>
                        </tr>
                        <tr>
                            <td class="px-4 py-3 font-medium">scope</td>
                            <td class="px-4 py-3">List of scopes that the authorized application has access to. Scopes
                                are separated by space.</td>
                            <td class="px-4 py-3">string</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="border rounded-lg p-5 bg-white shadow-sm">
            <h3 class="text-xl font-semibold text-gray-800 mb-3">2nd Method</h3>
            <div class="mb-4">
                <div class="font-medium text-gray-900">POST /api/partners/manager/v1/oauth2/token</div>
            </div>

            <h4 class="text-lg font-semibold text-blue-700 mb-3">
                Examples of Authorization using the Private JWT Key
            </h4>

            <p class="mb-4">
                The endpoint <span class="font-semibold">POST /oauth/token</span> is used to authorize
                the credentials of an application and obtain the necessary accesses to use other resources of the API.
            </p>

            <div class="bg-black text-white rounded-lg p-4 overflow-x-auto text-sm mb-6">
                <pre class="bg-black whitespace-pre-wrap" ngNonBindable>curl --location '<span class="text-[#e6db74]">BASE_URL/neobank/api/partners/manager/v1/oauth2/token</span>' \
--header '<span class="text-[#E6DB74]">ACCESS-USER</span>: "API_USER"' \
--header '<span class="text-[#E6DB74]">ACCESS-SIGNATURE</span>: LljhvQKC4MyhR8OqQChxJ4UurP4lpsi8rvJF0KEMrdM=' \
--header '<span class="text-[#E6DB74]">ACCESS-TIMESTAMP</span>: 1773062434' \
--header 'Content-Type: application/json' \
--data '&#123;
    "<span class="text-[#9CDCFE]">grantType</span>": "anything for now",
    "<span class="text-[#9CDCFE]">clientAssertionType</span>": "urn:ietf:params:oauth:client-assertion-type:jwt-bearer",
    "<span class="text-[#9CDCFE]">clientAssertion</span>": "JWT signed by the Partner's private key"
&#125;'</pre>
            </div>

            <div class="overflow-x-auto mb-6">
                <table class="min-w-full border border-gray-200 text-sm">
                    <thead class="bg-gray-100">
                        <tr>
                            <th class="px-4 py-3 text-left border-b">Attribute</th>
                            <th class="px-4 py-3 text-left border-b">Description</th>
                            <th class="px-4 py-3 text-left border-b">Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="border-b">
                            <td class="px-4 py-3 font-medium">ACCESS-USER</td>
                            <td class="px-4 py-3">API User</td>
                            <td class="px-4 py-3">string</td>
                        </tr>
                        <tr class="border-b">
                            <td class="px-4 py-3 font-medium">ACCESS-SIGNATURE</td>
                            <td class="px-4 py-3">HMAC SHA256 of Timestamp and API Key</td>
                            <td class="px-4 py-3">string</td>
                        </tr>
                        <tr class="border-b">
                            <td class="px-4 py-3 font-medium">ACCESS-TIMESTAMP</td>
                            <td class="px-4 py-3">EpochTime</td>
                            <td class="px-4 py-3">UUID</td>
                        </tr>
                        <!-- <tr class="border-b">
                            <td class="px-4 py-3 font-medium">clientId</td>
                            <td class="px-4 py-3">API User</td>
                            <td class="px-4 py-3">string</td>
                        </tr> -->
                        <tr class="border-b">
                            <td class="px-4 py-3 font-medium">grantType</td>
                            <td class="px-4 py-3"></td>
                            <td class="px-4 py-3">string</td>
                        </tr>
                        <tr class="border-b">
                            <td class="px-4 py-3 font-medium">clientAssertionType</td>
                            <td class="px-4 py-3">urn:ietf:params:oauth:client-assertion-type:jwt-bearer</td>
                            <td class="px-4 py-3">string</td>
                        </tr>
                        <tr>
                            <td class="px-4 py-3 font-medium">clientAssertion</td>
                            <td class="px-4 py-3">JWT signed by the Partner's private key</td>
                            <td class="px-4 py-3">string</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="mb-6">
                <h4 class="text-lg font-semibold text-blue-700 mb-3">JWT signed by the Partner</h4>

                <div class="mb-4">
                    <div class="font-semibold text-gray-800 mb-2">Header</div>
                    <div class="bg-black text-white rounded-lg p-4 overflow-x-auto text-sm mb-6">
                        <pre class="bg-black whitespace-pre-wrap" ngNonBindable>&#123;
  "<span class="text-[#ff8f40]">alg</span>": "RS256",
  "<span class="text-[#ff8f40]">typ</span>": "JWT"
&#125;</pre>
                    </div>
                </div>

                <div class="mb-4">
                    <div class="font-semibold text-gray-800 mb-2">Payload</div>
                    <div class="bg-black text-white rounded-lg p-4 overflow-x-auto text-sm mb-6">
                        <pre class="bg-black whitespace-pre-wrap" ngNonBindable>&#123;
  "<span class="text-[#ff8f40]">jti</span>": "61560e89-331d-4908-bff2-ec86f4f45ecc",
  "<span class="text-[#ff8f40]">sub</span>": "EEEALxvm5U2qE3zzTDOH7050SAop",
  "<span class="text-[#ff8f40]">iss</span>": "EEEALxvm5U2qE3zzTDOH7050SAop",
  "<span class="text-[#ff8f40]">aud</span>": "",
  "<span class="text-[#ff8f40]">exp</span>": 1536165540,
  "<span class="text-[#ff8f40]">iat</span>": 1772747779
&#125;</pre>
                    </div>
                </div>

                <div>
                    <div class="font-semibold text-gray-800 mb-2">Private Key</div>
                    <div class="bg-black text-white rounded-lg p-4 overflow-x-auto text-sm mb-6">
                        <pre class="bg-black whitespace-pre-wrap" ngNonBindable>-----BEGIN PRIVATE KEY-----
MIIEvwIBADANBgkqhkiG9w0BAQEFAASCBKkwggSlAgEAAoIBAQDDPfIray9wZQOK
cwHCE1oNug+IqfEk37K0KneAJmUp7ikSeGYwidqnzRj3q..........4gOFwnWz
+35kOm6tMlt+15iT/p126b+75K5HTWFKhZMN4Pkll1zHpXpaKzoRYBEJ
F6lQFgDzs7LKe3eGWUPpgLkt9Q==
-----END PRIVATE KEY-----</pre>
                    </div>
                </div>
            </div>

            <h4 class="text-lg font-semibold text-blue-700 mb-3">Generating a JWT (RS256) in various languages</h4>

            <div class="flex space-x-2 mb-4">

                <button (click)="selectTab('java')" [class.selected-tab]="selectedTab === 'java'"
                    [class.bg-gray-200]="selectedTab !== 'java'" class="px-4 py-2 rounded font-semibold">
                    Java (RS256)
                </button>

                <button (click)="selectTab('python')" [class.selected-tab]="selectedTab === 'python'"
                    [class.bg-gray-200]="selectedTab !== 'python'" class="px-4 py-2 rounded font-semibold">
                    Python (RS256)
                </button>

                <button (click)="selectTab('php')" [class.selected-tab]="selectedTab === 'php'"
                    [class.bg-gray-200]="selectedTab !== 'php'" class="px-4 py-2 rounded font-semibold">
                    PHP (RS256)
                </button>

            </div>

            <!-- Code Display -->
            <div class="bg-black text-white rounded-lg p-4 overflow-x-auto text-sm mb-4">
                <pre class="bg-black whitespace-pre-wrap">
                    <code>
                        {{ selectedTab === 'java' ? javaCode : selectedTab === 'python' ? pythonCode : phpCode }}
                    </code>
                </pre>
            </div>

            <h4 class="text-lg font-semibold text-blue-700 mb-3">Example of authorization response</h4>
            <p class="mb-4">
                Below is a code snippet representing an example of the OAuth response to your authorization request:
            </p>

            <div class="bg-black text-white rounded-lg p-4 overflow-x-auto text-sm mb-6">
                <pre class="bg-black whitespace-pre-wrap" ngNonBindable>&#123;
    "success": true,
    "message": "Login Successfully",
    "userDTO": &#123;
        "senderId": 23508,
        "tokenResponseDTO": &#123;
            "success": true,
            "message": "User Token Processed successfully",
            "tokenType": "Bearer",
            "accessToken": "eyJjdHkiOiJKV1QiLCJlbmMiOiJBMjU2R0NNIiwiYWxnIjoiZGlyIn0..cz9qafT08PZFsNLK.R_UOeMtDaG3IhtoQs6TOdLfDiSpYfAv4UfgDbs1SoI5HExtwpeNpFmZ79ZEblWFKTYP675uzTM_kaqnR7ZNhN2zG00sOJ0eQPLnG1QsCL50gqqKSXHp8aCzF6Crn2_MDQi5ly_D871Fb2fcvzgpNqGb_Zdv1o8YkpKS4wI52m5dcr1SLf6EOTu5g4te12Gv0NPFu7GD1UDHOhd1YqbnuwljOWrxRRnQ_2et1rTM1xGc.M9m3btLWyMzmV6Lna0M8Pw",
            "expiresIn": 1800,
            "scope": "MANAGER",
            "refreshToken": "2m8xhfIb0-_Szo-K5sULNq3_eQxUua20jmNkNFvDkG4="
        &#125;,
        "commissionSenderIds": [
            13
        ],
        "grantType": "client_credential"
    &#125;,
    "encryptedTellerKey": "3jJ2lOhzxxaNQMbKNeo8HxrztP9jglYvEELAiNRlS3c=",
    "dynamicSalt": "ey35Irt4TLsD1lun",
    "tellerSecretKey": "1fd029"
&#125;</pre>
            </div>
        </div>

        <div class="bg-shape-color-refresh-token p-4 rounded-lg">
            <h2 class="text-2xl font-semibold">REFRESH TOKEN DESCRIPTION AND USAGE</h2>
            <p>
                Use This API when you have a <span class="font-semibold">401 Error</span> on API, after first
                authentication.
            </p>
        </div>

        <div>
            <h2 class="text-2xl font-semibold text-blue-700 mb-4">Obtaining Refresh Token</h2>
        </div>

        <div class="border rounded-lg p-5 bg-white shadow-sm">
            <h3 class="text-xl font-semibold text-gray-800 mb-3">1st Method</h3>
            <div class="mb-4">
                <div class="font-medium text-gray-900">POST /api/partners/manager/v1/oauth2/refreshToken</div>
            </div>

            <h4 class="text-lg font-semibold text-blue-700 mb-3">
                Examples of Refresh Authorization using the Credentials Method
            </h4>

            <p class="mb-4">
                The endpoint <span class="font-semibold">POST /oauth2/refreshToken</span> is used to authorize
                the credentials of an application and obtain the necessary accesses to use other resources of the API.
            </p>

            <div class="bg-black text-white rounded-lg p-4 overflow-x-auto text-sm mb-6">
                <pre class="bg-black whitespace-pre-wrap" ngNonBindable>curl --location '<span class="text-[#e6db74]">BASE_URL/neobank/api/partners/manager/v1/oauth2/refreshToken</span>' \
--header 'Content-Type: application/json' \
--header 'Authorization: ••••••' \
--data '&#123;
    "refreshToken": "INSERT_YOUR_REFRESH_TOKEN_VALUE"
&#125;'</pre>
            </div>
        </div>

        <div class="border rounded-lg p-5 bg-white shadow-sm">
            <h3 class="text-xl font-semibold text-gray-800 mb-3">2nd Method</h3>
            <div class="mb-4">
                <div class="font-medium text-gray-900">POST /api/partners/manager/v1/oauth2/refreshToken/token</div>
            </div>

            <h4 class="text-lg font-semibold text-blue-700 mb-3">
                Examples of Refresh Authorization using the Private JWT Key
            </h4>

            <p class="mb-4">
                The endpoint <span class="font-semibold">POST /oauth2/refreshToken/token</span> is used to authorize
                the credentials of an application and obtain the necessary accesses to use other resources of the API.
            </p>

            <div class="bg-black text-white rounded-lg p-4 overflow-x-auto text-sm mb-6">
                <pre class="bg-black whitespace-pre-wrap" ngNonBindable>curl --location '<span class="text-[#e6db74]">BASE_URL/neobank/api/partners/manager/v1/oauth2/refreshToken/token</span>' \
--header '<span class="text-[#E6DB74]">ACCESS-USER</span>: "API_USER"' \
--header '<span class="text-[#E6DB74]">ACCESS-SIGNATURE</span>: LljhvQKC4MyhR8OqQChxJ4UurP4lpsi8rvJF0KEMrdM=' \
--header '<span class="text-[#E6DB74]">ACCESS-TIMESTAMP</span>: 1773062434' \
--header 'Content-Type: application/json' \
--data '&#123;
    "<span class="text-[#9CDCFE]">refreshToken</span>": "INSERT_YOUR_REFRESH_TOKEN_VALUE",
    "<span class="text-[#9CDCFE]">grantType</span>": "anything for now",
    "<span class="text-[#9CDCFE]">clientAssertionType</span>": "urn:ietf:params:oauth:client-assertion-type:jwt-bearer",
    "<span class="text-[#9CDCFE]">clientAssertion</span>": "JWT signed by the Partner's private key"
&#125;'</pre>
            </div>
        </div>

    </div>
</div>